import { useEffect } from 'react'
import { useSessionStore } from '@/store/sessionStore'
import { apiFetch } from '@/api/client'

interface SessionResponse {
  authenticated: boolean
  playerId: string
  displayName: string
  isAdmin: boolean
  lockAt: number
}

export function useSession() {
  const store = useSessionStore()

  useEffect(() => {
    if (!store.token) return
    apiFetch<SessionResponse>('/session', { token: store.token })
      .then(data => {
        if (data.authenticated) {
          store.setLockAt(data.lockAt)
        } else {
          store.clearSession()
        }
      })
      .catch(() => {})
  }, [store.token])

  return store
}
